export const METHODS = {
    SYNC_PROGRESS: 'syncProgress',
    FAILED_PROGRESS: 'syncFailed',
    FAILED_BUT_HAS_PRODUCTS: 'failedButHasProducts',
    ONLY_CSV: 'onlyCsv'
};
